import type { LucideIcon, LucideProps } from "lucide-react";
import type { ReactNode } from "react";

/** アプリのアイコンの線の太さ。lucideの既定の2より太くする。 */
export const ICON_STROKE_WIDTH = 2.5;

export type IconProps = Omit<
  LucideProps,
  "ref" | "strokeWidth" | "absoluteStrokeWidth"
> & {
  /** 図柄を塗りつぶす。お気に入りやピン留めなど、オンの状態を示す。 */
  filled?: boolean;
};
export type IconComponent = (props: IconProps) => ReactNode;

/**
 * lucideの図柄を、線の太さをそろえたアイコンにする。読み上げ用の名前を渡さないと、
 * lucideが飾りとして読み上げから外す。使うアイコンだけが配信物に入るように、
 * アイコンは1ファイルに1つずつ置く。
 */
export function createIcon(Glyph: LucideIcon): IconComponent {
  return function Icon({ filled = false, ...props }) {
    return (
      <Glyph
        {...props}
        strokeWidth={ICON_STROKE_WIDTH}
        {...(filled ? { fill: "currentColor" } : {})}
      />
    );
  };
}
